export default {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Aller Ã ',
  jump_to_confirm: 'confirmer',
  page: '',

  // Pagination.jsx
  prev_page: 'Page prÃ©cÃ©dente',
  next_page: 'Page suivante',
  prev_5: '5 Pages prÃ©cÃ©dentes',
  next_5: '5 Pages suivantes',
  prev_3: '3 Pages prÃ©cÃ©dentes',
  next_3: '3 Pages suivantes',
};
